<template>
  <div id="mkt">
    <div id="mainFixed2" class="mainFixed">
      <div class="pageTop">
        <div>
          <allSelect :checkIsSave="isAlreadyEdit"
            @on-change="brandChange"
            :disabled="brandList&&brandList.length>0?false:true"
            :chooseData="brandList"
            :needReturn="'Code'"
            :matchValue="'Name'"
            :showValue="'{{Name}}'"
            :state="'Status'" v-model="postData.brandCode"
            :width="'220px'">
          </allSelect>
        </div>
        <div v-if="mktData.ReadOnly&&!mktData.IsSubmitted" class="colorRed f_w Newline">{{$t('common.MKTNote')}}</div>
        <div class="mktVersion">
          <div>{{$t('common.CurrentVersion')}}：<span class="colorRed f_w">{{year}}{{month>9?month:('0'+month)}}</span></div>
          <div v-if="!hideBtn">{{$t('common.Status')}}：<span class="colorRed f_w">{{mktData.IsSubmitted?$t('common.PendingOk'):$t('common.Pending')}}</span></div>
          <div v-else>&nbsp;&nbsp;</div>
        </div>
      </div>
      <div class="d_flex tabBlock">
        <div class="d_flex versionTab">
          <button v-if="item.Code!='Sales'" v-for="(item,index) in moduleList" :key="index" :class="postData.version==item.Code?'selected':''" :disabled="!item.Enable" @click="changeVersion(item)">{{item.Name}}{{item.Code=='MKT'?$t('common.Version'):''}}</button>
        </div>
        <div v-if="postData.version!='PreSOP_Shipment'&&postData.version!='SOP_Shipment'" class="d_flex m_r_10 m_b_10">※ {{$t('common.Reason7')}}：<span class="colorA f_w">A</span>&nbsp;{{$t('common.ForActualSales')}}<span class="colorF f_w">F</span>&nbsp;{{$t('common.ForForecast')}}</div>
      </div>
      <div class="allSearch d_flex">
        <dl class="d_flex">
          <dd>
            <span class="f_w">{{$t('common.Year')}}:</span>
            <div class="dis_line v_m padWidth">
              <allSelect @on-change="yearChange" :chooseData="yearList" :needReturn="'Code'" :matchValue="'Name'" :showValue="'{{Name}}'" v-model="postData.year" :width="'100%'">
              </allSelect>
            </div>
          </dd>
          <dd v-if="postData.version=='PreSOP_Shipment'||postData.version=='SOP_Shipment'">
            <span class="f_w">{{$t('common.LastMonthEndingInventory')}}:</span>
            <div class="dis_line v_m padWidth">
              <input type="text" @input="postData.LastEndingInventoryInput=postData.LastEndingInventoryInput==0||postData.LastEndingInventoryInput=='00'?0:postData.LastEndingInventoryInput.replace(/\D|^[0]+/g,'')" class="allInput font12 padInputWidth" @change="alreadyEdit()" :disabled="!mktData||mktData.IsSubmitted||postData.version=='SOP_Shipment'" v-model="postData.LastEndingInventoryInput">
            </div>
          </dd>
          <dd v-if="postData.version=='PreSOP_Shipment'||postData.version=='SOP_Shipment'">
            <span class="f_w">{{$t('common.MOH')}}:</span>
            <div class="dis_line v_m padMohWidth">
              <allSelect @on-change="mohChange" :chooseData="mohSelectData" :needReturn="'Code'" :matchValue="'Name'" :showValue="'{{Name}}'" v-model="postData.MOHMonthNum" :width="'100%'">
              </allSelect>
            </div>
          </dd>
          <dt class="d_flex" v-if="postData.version=='MKT'&&false">
            <button v-if="item.Code=='Sales'" v-for="(item,index) in moduleList" :key="index" class="cancelButtonRed" :disabled="!item.Enable||postData.brandCode=='B004'" @click="showNsdDialog()">{{item.Name}}{{$t('common.Version')}}</button>
          </dt>
        </dl>
        <dl>
          <dd style="margin-right: 0;">
            <button v-if="postData.version=='MKT'" class="cancelButton m_r_5" @click="showInstruction()">
              <i class="icon iconfont icon-info" style="font-size: 16px!important;"></i>
              {{$t('common.Instruction')}}
            </button>
            <button v-if="!hideBtn&&(postData.version=='PreSOP_Shipment'||postData.version=='SOP_Shipment')" class="redButton m_r_5" :disabled="!(mktData&&mktData.ShipmentInfoModelList&&mktData.IsEditable)" @click="saveAndRefresh()"><i class="icon iconfont icon-166991"></i>{{$t('common.SaveAndRefresh')}}</button>
            <button v-if="!hideBtn&&postData.version!='PreSOP_Shipment'" class="redButton m_r_5" :disabled="!mktData||(!mktData.IsSubmitted&&postData.version=='PreSOP')" @click="downLoad()"><i class="icon iconfont icon-xiazai"></i>{{$t('common.Download')}}</button>
            <button v-if="mktData&&mktData.CanSubmit&&!mktData.IsSubmitted" class="greenButton" @click="showCommitDialog()"><i class="icon iconfont icon-tijiao"></i>{{postData.version!='MKT'&&postData.version!='PreSOP_Shipment'&&postData.version!='SOP_Shipment'?$t('common.Preview'):(postData.version=='SOP_Shipment'?$t('common.Complete'):$t('common.Submit'))}}</button>
          </dd>
        </dl>
      </div>
      <table style="table-layout: fixed;" id="noScroll" class="allTable" cellspacing="0">
        <thead>
        <tr>
          <th class="expendW"></th>
          <th v-if="postData.version!='PreSOP_Shipment'&&postData.version!='SOP_Shipment'">&nbsp;</th><!-- {{$t('common.Group')}} -->
          <th v-if="postData.version!='PreSOP_Shipment'&&postData.version!='SOP_Shipment'">&nbsp;</th><!-- {{$t('common.Subgroup')}} -->
          <th v-else></th>
          <th>{{$t('common.AnnualTotal')}}</th>
          <th>{{$t('common.1M')}}</th>
          <th>{{$t('common.2M')}}</th>
          <th>{{$t('common.3M')}}</th>
          <th>{{$t('common.4M')}}</th>
          <th>{{$t('common.5M')}}</th>
          <th>{{$t('common.6M')}}</th>
          <th>{{$t('common.7M')}}</th>
          <th>{{$t('common.8M')}}</th>
          <th>{{$t('common.9M')}}</th>
          <th>{{$t('common.10M')}}</th>
          <th>{{$t('common.11M')}}</th>
          <th>{{$t('common.12M')}}</th>
        </tr>
        </thead>
        <tbody v-if="postData.version!='PreSOP_Shipment'&&postData.version!='SOP_Shipment'">
          <!-- 汇总全国 -->
          <tr ref="totalTr" class="colorRed f_w" v-if="mktData">
            <td class="expendW"></td>
            <td class="c_p" @click="typeEvent('')">&nbsp;</td><!-- {{$t('common.AllTotal')}} -->
            <td class="c_p" @click="typeEvent('')">{{$t('common.Nationwide')}}</td>
            <td class="salesBorder">{{$commonJs.numFixed(mktData.AnnutalTotal)}}</td>
            <td>{{$commonJs.numFixed(mktData.January)}}</td>
            <td>{{$commonJs.numFixed(mktData.February)}}</td>
            <td>{{$commonJs.numFixed(mktData.March)}}</td>
            <td>{{$commonJs.numFixed(mktData.April)}}</td>
            <td>{{$commonJs.numFixed(mktData.May)}}</td>
            <td>{{$commonJs.numFixed(mktData.June)}}</td>
            <td>{{$commonJs.numFixed(mktData.July)}}</td>
            <td>{{$commonJs.numFixed(mktData.August)}}</td>
            <td>{{$commonJs.numFixed(mktData.September)}}</td>
            <td>{{$commonJs.numFixed(mktData.October)}}</td>
            <td>{{$commonJs.numFixed(mktData.November)}}</td>
            <td>{{$commonJs.numFixed(mktData.December)}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="mainScroll" :style="(showChartFlag?'margin-bottom: 288px;':'margin-bottom: 118px;')+'padding-top:'+mainScrollTop+'px'">
      <table v-if="postData.version!='PreSOP_Shipment'&&postData.version!='SOP_Shipment'" style="table-layout: fixed;" class="allTable" cellspacing="0">
        <tbody :key="index" v-for="(item, index) in mktData.MarketGroups" v-if="mktData.MarketGroups&&mktData.MarketGroups.length > 0">
          <!-- 大类汇总 -->
          <tr v-if="item.GroupName!='其他渠道'&&item.GroupName!='预测汇总调整'" :style="item.GroupName=='业务团队'?'color: #777;':''" class="f_w">
            <td class="expendW" v-if="item.GroupName=='业务团队'"></td>
            <td class="expendW" v-else :class="item.SubGroups&&item.SubGroups.length>0?'expend_able':'expend_disable'" @click="item.SubGroups&&item.SubGroups.length>0?expendRow(item.GroupId):''">{{expendRowCode == item.GroupId?$t('common.PackUp')+'>':$t('common.Expand')}}</td>
            <td v-if="item.GroupName=='业务团队'" class="c_p" @click="typeEvent(item.GroupId)" style="color:#1E1E1E;">&nbsp;</td><!-- {{$t('common.TargetHospital')}} -->
            <td v-if="item.GroupName=='其他渠道'" class="c_p" @click="typeEvent(item.GroupId)">{{$t('common.NonTarget')}}</td>
            <td v-if="item.GroupName!='业务团队'&&item.GroupName!='其他渠道'" class="c_p" @click="typeEvent(item.GroupId)">{{item.GroupName}}</td>
            <td class="c_p" @click="typeEvent(item.GroupId)">{{item.GroupName=='业务团队'?$t('common.TargetHospital-Target'):$t('common.Nationwide')}}</td>
            <td class="salesBorder">{{$commonJs.numFixed(item.AnnutalTotal)}}</td>
            <td>{{item.GroupName=='业务团队'&&item.January==null?'':$commonJs.numFixed(item.January)}}</td>
            <td>{{item.GroupName=='业务团队'&&item.February==null?'':$commonJs.numFixed(item.February)}}</td>
            <td>{{item.GroupName=='业务团队'&&item.March==null?'':$commonJs.numFixed(item.March)}}</td>
            <td>{{item.GroupName=='业务团队'&&item.April==null?'':$commonJs.numFixed(item.April)}}</td>
            <td>{{item.GroupName=='业务团队'&&item.May==null?'':$commonJs.numFixed(item.May)}}</td>
            <td>{{item.GroupName=='业务团队'&&item.June==null?'':$commonJs.numFixed(item.June)}}</td>
            <td>{{item.GroupName=='业务团队'&&item.July==null?'':$commonJs.numFixed(item.July)}}</td>
            <td>{{item.GroupName=='业务团队'&&item.August==null?'':$commonJs.numFixed(item.August)}}</td>
            <td>{{item.GroupName=='业务团队'&&item.September==null?'':$commonJs.numFixed(item.September)}}</td>
            <td>{{item.GroupName=='业务团队'&&item.October==null?'':$commonJs.numFixed(item.October)}}</td>
            <td>{{item.GroupName=='业务团队'&&item.November==null?'':$commonJs.numFixed(item.November)}}</td>
            <td>{{item.GroupName=='业务团队'&&item.December==null?'':$commonJs.numFixed(item.December)}}</td>
          </tr>
          <!-- 子类 -->
          <tr v-if="expendRowCode==item.GroupId||item.GroupName=='业务团队'||item.GroupName=='其他渠道'||item.GroupName=='预测汇总调整'" :style="item.GroupName=='业务团队'||item.GroupName=='其他渠道'||item.GroupName=='预测汇总调整'?'font-weight:bold;':''"
            :key="j" v-for="(subItem, j) in item.SubGroups">
            <td class="expendW"></td>
            <td :class="item.GroupName=='其他渠道'||item.GroupName=='预测汇总调整'?'c_p':''" @click="item.GroupName=='其他渠道'||item.GroupName=='预测汇总调整'?typeEvent(item.GroupId):''">{{item.GroupName=='其他渠道'?$t('common.NonTarget'):''}}{{item.GroupName=='预测汇总调整'?$t('common.FcstAdjustment'):''}}</td>
            <td class="c_p" @click="typeEvent(item.GroupId)">{{item.GroupName=='其他渠道'||item.GroupName=='预测汇总调整'?$t('common.Nationwide'):subItem.SubGroupName}}</td>
            <td class="salesBorder">{{$commonJs.numFixed(subItem.AnnutalTotal)}}</td>
            <td :class="getCanEdit(subItem.IsEditable,1)?'editBC':''">
              <div style="display: flex;justify-content: space-between;align-items: center;">
                <mktEdit :canEdit="getCanEdit(subItem.IsEditable,1)" :value="subItem.January" v-model="subItem.January" @changeValue="saveData($event,1,subItem.Id,subItem.JanuaryRemark)"></mktEdit>
                <mktReason v-model="subItem.JanuaryRemark" :canEdit="getCanEdit(subItem.IsEditable,1)" @changeValue="saveDataR($event,1,subItem.Id,subItem.January)"></mktReason>
              </div>
            </td>
            <td :class="getCanEdit(subItem.IsEditable,2)?'editBC':''">
              <div style="display: flex;justify-content: space-between;align-items: center;">
              <mktEdit :canEdit="getCanEdit(subItem.IsEditable,2)" :value="subItem.February" v-model="subItem.February" @changeValue="saveData($event,2,subItem.Id,subItem.FebruaryRemark)"></mktEdit>
              <mktReason v-model="subItem.FebruaryRemark" :canEdit="getCanEdit(subItem.IsEditable,2)" @changeValue="saveDataR($event,2,subItem.Id,subItem.February)"></mktReason>
              </div>
            </td>
            <td :class="getCanEdit(subItem.IsEditable,3)?'editBC':''">
              <div style="display: flex;justify-content: space-between;align-items: center;">
              <mktEdit :canEdit="getCanEdit(subItem.IsEditable,3)" :value="subItem.March" v-model="subItem.March" @changeValue="saveData($event,3,subItem.Id,subItem.MarchRemark)"></mktEdit>
              <mktReason v-model="subItem.MarchRemark" :canEdit="getCanEdit(subItem.IsEditable,3)" @changeValue="saveDataR($event,3,subItem.Id,subItem.March)"></mktReason>
              </div>
            </td>
            <td :class="getCanEdit(subItem.IsEditable,4)?'editBC':''">
              <div style="display: flex;justify-content: space-between;align-items: center;">
              <mktEdit :canEdit="getCanEdit(subItem.IsEditable,4)" :value="subItem.April" v-model="subItem.April" @changeValue="saveData($event,4,subItem.Id,subItem.AprilRemark)"></mktEdit>
              <mktReason v-model="subItem.AprilRemark" :canEdit="getCanEdit(subItem.IsEditable,4)" @changeValue="saveDataR($event,4,subItem.Id,subItem.April)"></mktReason>
              </div>
            </td>
            <td :class="getCanEdit(subItem.IsEditable,5)?'editBC':''">
              <div style="display: flex;justify-content: space-between;align-items: center;">
              <mktEdit :canEdit="getCanEdit(subItem.IsEditable,5)" :value="subItem.May" v-model="subItem.May" @changeValue="saveData($event,5,subItem.Id,subItem.MayRemark)"></mktEdit>
              <mktReason v-model="subItem.MayRemark" :canEdit="getCanEdit(subItem.IsEditable,5)" @changeValue="saveDataR($event,5,subItem.Id,subItem.May)"></mktReason>
              </div>
            </td>
            <td :class="getCanEdit(subItem.IsEditable,6)?'editBC':''">
              <div style="display: flex;justify-content: space-between;align-items: center;">
              <mktEdit :canEdit="getCanEdit(subItem.IsEditable,6)" :value="subItem.June" v-model="subItem.June" @changeValue="saveData($event,6,subItem.Id,subItem.JuneRemark)"></mktEdit>
              <mktReason v-model="subItem.JuneRemark" :canEdit="getCanEdit(subItem.IsEditable,6)" @changeValue="saveDataR($event,6,subItem.Id,subItem.June)"></mktReason>
              </div>
            </td>
            <td :class="getCanEdit(subItem.IsEditable,7)?'editBC':''">
              <div style="display: flex;justify-content: space-between;align-items: center;">
              <mktEdit :canEdit="getCanEdit(subItem.IsEditable,7)" :value="subItem.July" v-model="subItem.July" @changeValue="saveData($event,7,subItem.Id,subItem.JulyRemark)"></mktEdit>
              <mktReason v-model="subItem.JulyRemark" :canEdit="getCanEdit(subItem.IsEditable,7)" @changeValue="saveDataR($event,7,subItem.Id,subItem.July)"></mktReason>
              </div>
            </td>
            <td :class="getCanEdit(subItem.IsEditable,8)?'editBC':''">
              <div style="display: flex;justify-content: space-between;align-items: center;">
              <mktEdit :canEdit="getCanEdit(subItem.IsEditable,8)" :value="subItem.August" v-model="subItem.August" @changeValue="saveData($event,8,subItem.Id,subItem.AugustRemark)"></mktEdit>
              <mktReason v-model="subItem.AugustRemark" :canEdit="getCanEdit(subItem.IsEditable,8)" @changeValue="saveDataR($event,8,subItem.Id,subItem.August)"></mktReason>
              </div>
            </td>
            <td :class="getCanEdit(subItem.IsEditable,9)?'editBC':''">
              <div style="display: flex;justify-content: space-between;align-items: center;">
              <mktEdit :canEdit="getCanEdit(subItem.IsEditable,9)" :value="subItem.September" v-model="subItem.September" @changeValue="saveData($event,9,subItem.Id,subItem.SeptemberRemark)"></mktEdit>
              <mktReason v-model="subItem.SeptemberRemark" :canEdit="getCanEdit(subItem.IsEditable,9)" @changeValue="saveDataR($event,9,subItem.Id,subItem.September)"></mktReason>
              </div>
            </td>
            <td :class="getCanEdit(subItem.IsEditable,10)?'editBC':''">
              <div style="display: flex;justify-content: space-between;align-items: center;">
              <mktEdit :canEdit="getCanEdit(subItem.IsEditable,10)" :value="subItem.October" v-model="subItem.October" @changeValue="saveData($event,10,subItem.Id,subItem.OctoberRemark)"></mktEdit>
              <mktReason v-model="subItem.OctoberRemark" :canEdit="getCanEdit(subItem.IsEditable,10)" @changeValue="saveDataR($event,10,subItem.Id,subItem.October)"></mktReason>
              </div>
            </td>
            <td :class="getCanEdit(subItem.IsEditable,11)?'editBC':''">
              <div style="display: flex;justify-content: space-between;align-items: center;">
              <mktEdit :canEdit="getCanEdit(subItem.IsEditable,11)" :value="subItem.November" v-model="subItem.November" @changeValue="saveData($event,11,subItem.Id,subItem.NovemberRemark)"></mktEdit>
              <mktReason v-model="subItem.NovemberRemark" :canEdit="getCanEdit(subItem.IsEditable,11)" @changeValue="saveDataR($event,11,subItem.Id,subItem.November)"></mktReason>
              </div>
            </td>
            <td :class="getCanEdit(subItem.IsEditable,12)?'editBC':''">
              <div style="display: flex;justify-content: space-between;align-items: center;">
              <mktEdit :canEdit="getCanEdit(subItem.IsEditable,12)" :value="subItem.December" v-model="subItem.December" @changeValue="saveData($event,12,subItem.Id,subItem.DecemberRemark)"></mktEdit>
              <mktReason v-model="subItem.DecemberRemark" :canEdit="getCanEdit(subItem.IsEditable,12)" @changeValue="saveDataR($event,12,subItem.Id,subItem.December)"></mktReason>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody v-if="(!mktData)||(!mktData.MarketGroups)||mktData.MarketGroups.length == 0">
          <tr>
            <td colspan="16" class="t_c colorGray bot_bottom">{{$t('common.noData')}}</td>
          </tr>
        </tbody>
      </table>
      <!-- Shipment版本Table -->
      <table v-else style="table-layout: fixed;" class="allTable" cellspacing="0">
        <tbody :key="index" v-for="(item, index) in mktData.ShipmentInfoModelList" v-if="mktData&&mktData.ShipmentInfoModelList&&mktData.ShipmentInfoModelList.length>0&&postData.year==item.Year">
          <tr class="f_w">
            <td class="expendW"></td>
            <td>Begining Inventories</td>
            <td class="salesBorder">
            <!-- {{$commonJs.numFixed(item.BeginingInventories.AnnutalTotal)}} -->
            </td>
            <td>{{$commonJs.numFixed(item.BeginingInventories.Jan)}}</td>
            <td>{{$commonJs.numFixed(item.BeginingInventories.Feb)}}</td>
            <td>{{$commonJs.numFixed(item.BeginingInventories.Mar)}}</td>
            <td>{{$commonJs.numFixed(item.BeginingInventories.Apr)}}</td>
            <td>{{$commonJs.numFixed(item.BeginingInventories.May)}}</td>
            <td>{{$commonJs.numFixed(item.BeginingInventories.Jun)}}</td>
            <td>{{$commonJs.numFixed(item.BeginingInventories.Jul)}}</td>
            <td>{{$commonJs.numFixed(item.BeginingInventories.Aug)}}</td>
            <td>{{$commonJs.numFixed(item.BeginingInventories.Sep)}}</td>
            <td>{{$commonJs.numFixed(item.BeginingInventories.Oct)}}</td>
            <td>{{$commonJs.numFixed(item.BeginingInventories.Nov)}}</td>
            <td>{{$commonJs.numFixed(item.BeginingInventories.Dec)}}</td>
          </tr>
          <tr class="f_w">
            <td :class="item.MKTForecast.ShipmentMKTGroupModel?'expend_able':'expend_disable'" @click="item.MKTForecast.ShipmentMKTGroupModel?expendRow('MKTForecastId'):''">{{expendRowCode == 'MKTForecastId'?$t('common.PackUp')+'>':$t('common.Expand')}}</td>
            <td>In MKT Biz Forecast</td>
            <td class="salesBorder">{{$commonJs.numFixed(item.MKTForecast.AnnutalTotal)}}</td>
            <td>{{$commonJs.numFixed(item.MKTForecast.Jan)}}</td>
            <td>{{$commonJs.numFixed(item.MKTForecast.Feb)}}</td>
            <td>{{$commonJs.numFixed(item.MKTForecast.Mar)}}</td>
            <td>{{$commonJs.numFixed(item.MKTForecast.Apr)}}</td>
            <td>{{$commonJs.numFixed(item.MKTForecast.May)}}</td>
            <td>{{$commonJs.numFixed(item.MKTForecast.Jun)}}</td>
            <td>{{$commonJs.numFixed(item.MKTForecast.Jul)}}</td>
            <td>{{$commonJs.numFixed(item.MKTForecast.Aug)}}</td>
            <td>{{$commonJs.numFixed(item.MKTForecast.Sep)}}</td>
            <td>{{$commonJs.numFixed(item.MKTForecast.Oct)}}</td>
            <td>{{$commonJs.numFixed(item.MKTForecast.Nov)}}</td>
            <td>{{$commonJs.numFixed(item.MKTForecast.Dec)}}</td>
          </tr>
          <tr v-if="expendRowCode=='MKTForecastId'">
            <td></td>
            <td>{{$t('common.FcstAdjustment')}}</td>
            <td class="salesBorder">{{$commonJs.numFixed(item.MKTForecast.ShipmentMKTGroupModel.AnnutalTotal)}}</td>
            <td :class="getCanEdit(item.IsEditable,1)?'editBC':''">
              <div style="display: flex;justify-content: space-between;align-items: center;">
                <mktEdit :canEdit="getCanEdit(item.IsEditable,1)" :value="item.MKTForecast.ShipmentMKTGroupModel.Jan" v-model="item.MKTForecast.ShipmentMKTGroupModel.Jan" @changeValue="alreadyEdit()"></mktEdit>
              </div>
            </td>
            <td :class="getCanEdit(item.IsEditable,2)?'editBC':''">
              <div style="display: flex;justify-content: space-between;align-items: center;">
                <mktEdit :canEdit="getCanEdit(item.IsEditable,2)" :value="item.MKTForecast.ShipmentMKTGroupModel.Feb" v-model="item.MKTForecast.ShipmentMKTGroupModel.Feb" @changeValue="alreadyEdit()"></mktEdit>
              </div>
            </td>
            <td :class="getCanEdit(item.IsEditable,3)?'editBC':''">
              <div style="display: flex;justify-content: space-between;align-items: center;">
                <mktEdit :canEdit="getCanEdit(item.IsEditable,3)" :value="item.MKTForecast.ShipmentMKTGroupModel.Mar" v-model="item.MKTForecast.ShipmentMKTGroupModel.Mar" @changeValue="alreadyEdit()"></mktEdit>
              </div>
            </td>
            <td :class="getCanEdit(item.IsEditable,4)?'editBC':''">
              <div style="display: flex;justify-content: space-between;align-items: center;">
                <mktEdit :canEdit="getCanEdit(item.IsEditable,4)" :value="item.MKTForecast.ShipmentMKTGroupModel.Apr" v-model="item.MKTForecast.ShipmentMKTGroupModel.Apr" @changeValue="alreadyEdit()"></mktEdit>
              </div>
            </td>
            <td :class="getCanEdit(item.IsEditable,5)?'editBC':''">
              <div style="display: flex;justify-content: space-between;align-items: center;">
                <mktEdit :canEdit="getCanEdit(item.IsEditable,5)" :value="item.MKTForecast.ShipmentMKTGroupModel.May" v-model="item.MKTForecast.ShipmentMKTGroupModel.May" @changeValue="alreadyEdit()"></mktEdit>
              </div>
            </td>
            <td :class="getCanEdit(item.IsEditable,6)?'editBC':''">
              <div style="display: flex;justify-content: space-between;align-items: center;">
                <mktEdit :canEdit="getCanEdit(item.IsEditable,6)" :value="item.MKTForecast.ShipmentMKTGroupModel.Jun" v-model="item.MKTForecast.ShipmentMKTGroupModel.Jun" @changeValue="alreadyEdit()"></mktEdit>
              </div>
            </td>
            <td :class="getCanEdit(item.IsEditable,7)?'editBC':''">
              <div style="display: flex;justify-content: space-between;align-items: center;">
                <mktEdit :canEdit="getCanEdit(item.IsEditable,7)" :value="item.MKTForecast.ShipmentMKTGroupModel.Jul" v-model="item.MKTForecast.ShipmentMKTGroupModel.Jul" @changeValue="alreadyEdit()"></mktEdit>
              </div>
            </td>
            <td :class="getCanEdit(item.IsEditable,8)?'editBC':''">
              <div style="display: flex;justify-content: space-between;align-items: center;">
                <mktEdit :canEdit="getCanEdit(item.IsEditable,8)" :value="item.MKTForecast.ShipmentMKTGroupModel.Aug" v-model="item.MKTForecast.ShipmentMKTGroupModel.Aug" @changeValue="alreadyEdit()"></mktEdit>
              </div>
            </td>
            <td :class="getCanEdit(item.IsEditable,9)?'editBC':''">
              <div style="display: flex;justify-content: space-between;align-items: center;">
                <mktEdit :canEdit="getCanEdit(item.IsEditable,9)" :value="item.MKTForecast.ShipmentMKTGroupModel.Sep" v-model="item.MKTForecast.ShipmentMKTGroupModel.Sep" @changeValue="alreadyEdit()"></mktEdit>
              </div>
            </td>
            <td :class="getCanEdit(item.IsEditable,10)?'editBC':''">
              <div style="display: flex;justify-content: space-between;align-items: center;">
                <mktEdit :canEdit="getCanEdit(item.IsEditable,10)" :value="item.MKTForecast.ShipmentMKTGroupModel.Oct" v-model="item.MKTForecast.ShipmentMKTGroupModel.Oct" @changeValue="alreadyEdit()"></mktEdit>
              </div>
            </td>
            <td :class="getCanEdit(item.IsEditable,11)?'editBC':''">
              <div style="display: flex;justify-content: space-between;align-items: center;">
                <mktEdit :canEdit="getCanEdit(item.IsEditable,11)" :value="item.MKTForecast.ShipmentMKTGroupModel.Nov" v-model="item.MKTForecast.ShipmentMKTGroupModel.Nov" @changeValue="alreadyEdit()"></mktEdit>
              </div>
            </td>
            <td :class="getCanEdit(item.IsEditable,12)?'editBC':''">
              <div style="display: flex;justify-content: space-between;align-items: center;">
                <mktEdit :canEdit="getCanEdit(item.IsEditable,12)" :value="item.MKTForecast.ShipmentMKTGroupModel.Dec" v-model="item.MKTForecast.ShipmentMKTGroupModel.Dec" @changeValue="alreadyEdit()"></mktEdit>
              </div>
            </td>
          </tr>
          <tr class="f_w">
            <td></td>
            <td>{{$t('common.LastShipmentplan')}}</td>
            <td class="salesBorder">{{$commonJs.numFixed(item.LastMonthShipmentPlan.AnnutalTotal)}}</td>
            <td>{{$commonJs.numFixed(item.LastMonthShipmentPlan.Jan)}}</td>
            <td>{{$commonJs.numFixed(item.LastMonthShipmentPlan.Feb)}}</td>
            <td>{{$commonJs.numFixed(item.LastMonthShipmentPlan.Mar)}}</td>
            <td>{{$commonJs.numFixed(item.LastMonthShipmentPlan.Apr)}}</td>
            <td>{{$commonJs.numFixed(item.LastMonthShipmentPlan.May)}}</td>
            <td>{{$commonJs.numFixed(item.LastMonthShipmentPlan.Jun)}}</td>
            <td>{{$commonJs.numFixed(item.LastMonthShipmentPlan.Jul)}}</td>
            <td>{{$commonJs.numFixed(item.LastMonthShipmentPlan.Aug)}}</td>
            <td>{{$commonJs.numFixed(item.LastMonthShipmentPlan.Sep)}}</td>
            <td>{{$commonJs.numFixed(item.LastMonthShipmentPlan.Oct)}}</td>
            <td>{{$commonJs.numFixed(item.LastMonthShipmentPlan.Nov)}}</td>
            <td>{{$commonJs.numFixed(item.LastMonthShipmentPlan.Dec)}}</td>
          </tr>
          <tr class="f_w">
            <td></td>
            <td>{{$t('common.CurrentShipmentplan')}}</td>
            <td class="salesBorder">{{$commonJs.numFixed(item.CurrentMonthShipmentPlan.AnnutalTotal)}}</td>
            <td :class="getCanEdit(item.IsEditable,1, true)?'editBC':''">
              <div style="display: flex;justify-content: space-between;align-items: center;">
                <mktEdit :canEdit="getCanEdit(item.IsEditable,1, true)" :value="item.CurrentMonthShipmentPlan.Jan" v-model="item.CurrentMonthShipmentPlan.Jan" @changeValue="alreadyEdit()"></mktEdit>
              </div>
            </td>
            <td :class="getCanEdit(item.IsEditable,2, true)?'editBC':''">
              <div style="display: flex;justify-content: space-between;align-items: center;">
                <mktEdit :canEdit="getCanEdit(item.IsEditable,2, true)" :value="item.CurrentMonthShipmentPlan.Feb" v-model="item.CurrentMonthShipmentPlan.Feb" @changeValue="alreadyEdit()"></mktEdit>
              </div>
            </td>
            <td :class="getCanEdit(item.IsEditable,3, true)?'editBC':''">
              <div style="display: flex;justify-content: space-between;align-items: center;">
                <mktEdit :canEdit="getCanEdit(item.IsEditable,3, true)" :value="item.CurrentMonthShipmentPlan.Mar" v-model="item.CurrentMonthShipmentPlan.Mar" @changeValue="alreadyEdit()"></mktEdit>
              </div>
            </td>
            <td :class="getCanEdit(item.IsEditable,4, true)?'editBC':''">
              <div style="display: flex;justify-content: space-between;align-items: center;">
                <mktEdit :canEdit="getCanEdit(item.IsEditable,4, true)" :value="item.CurrentMonthShipmentPlan.Apr" v-model="item.CurrentMonthShipmentPlan.Apr" @changeValue="alreadyEdit()"></mktEdit>
              </div>
            </td>
            <td :class="getCanEdit(item.IsEditable,5, true)?'editBC':''">
              <div style="display: flex;justify-content: space-between;align-items: center;">
                <mktEdit :canEdit="getCanEdit(item.IsEditable,5, true)" :value="item.CurrentMonthShipmentPlan.May" v-model="item.CurrentMonthShipmentPlan.May" @changeValue="alreadyEdit()"></mktEdit>
              </div>
            </td>
            <td :class="getCanEdit(item.IsEditable,6, true)?'editBC':''">
              <div style="display: flex;justify-content: space-between;align-items: center;">
                <mktEdit :canEdit="getCanEdit(item.IsEditable,6, true)" :value="item.CurrentMonthShipmentPlan.Jun" v-model="item.CurrentMonthShipmentPlan.Jun" @changeValue="alreadyEdit()"></mktEdit>
              </div>
            </td>
            <td :class="getCanEdit(item.IsEditable,7, true)?'editBC':''">
              <div style="display: flex;justify-content: space-between;align-items: center;">
                <mktEdit :canEdit="getCanEdit(item.IsEditable,7, true)" :value="item.CurrentMonthShipmentPlan.Jul" v-model="item.CurrentMonthShipmentPlan.Jul" @changeValue="alreadyEdit()"></mktEdit>
              </div>
            </td>
            <td :class="getCanEdit(item.IsEditable,8, true)?'editBC':''">
              <div style="display: flex;justify-content: space-between;align-items: center;">
                <mktEdit :canEdit="getCanEdit(item.IsEditable,8, true)" :value="item.CurrentMonthShipmentPlan.Aug" v-model="item.CurrentMonthShipmentPlan.Aug" @changeValue="alreadyEdit()"></mktEdit>
              </div>
            </td>
            <td :class="getCanEdit(item.IsEditable,9, true)?'editBC':''">
              <div style="display: flex;justify-content: space-between;align-items: center;">
                <mktEdit :canEdit="getCanEdit(item.IsEditable,9, true)" :value="item.CurrentMonthShipmentPlan.Sep" v-model="item.CurrentMonthShipmentPlan.Sep" @changeValue="alreadyEdit()"></mktEdit>
              </div>
            </td>
            <td :class="getCanEdit(item.IsEditable,10, true)?'editBC':''">
              <div style="display: flex;justify-content: space-between;align-items: center;">
                <mktEdit :canEdit="getCanEdit(item.IsEditable,10, true)" :value="item.CurrentMonthShipmentPlan.Oct" v-model="item.CurrentMonthShipmentPlan.Oct" @changeValue="alreadyEdit()"></mktEdit>
              </div>
            </td>
            <td :class="getCanEdit(item.IsEditable,11, true)?'editBC':''">
              <div style="display: flex;justify-content: space-between;align-items: center;">
                <mktEdit :canEdit="getCanEdit(item.IsEditable,11, true)" :value="item.CurrentMonthShipmentPlan.Nov" v-model="item.CurrentMonthShipmentPlan.Nov" @changeValue="alreadyEdit()"></mktEdit>
              </div>
            </td>
            <td :class="getCanEdit(item.IsEditable,12, true)?'editBC':''">
              <div style="display: flex;justify-content: space-between;align-items: center;">
                <mktEdit :canEdit="getCanEdit(item.IsEditable,12, true)" :value="item.CurrentMonthShipmentPlan.Dec" v-model="item.CurrentMonthShipmentPlan.Dec" @changeValue="alreadyEdit()"></mktEdit>
              </div>
            </td>
          </tr>
          <tr class="f_w">
            <td></td>
            <td>Ending Inventories</td>
            <td class="salesBorder">
            <!--{{$commonJs.numFixed(item.EndingInventories.AnnutalTotal)}}-->
            </td>
            <td :class="postData.year==year&&month==1?'bgColorFDF1F4':''">{{$commonJs.numFixed(item.EndingInventories.Jan)}}</td>
            <td :class="postData.year==year&&month==2?'bgColorFDF1F4':''">{{$commonJs.numFixed(item.EndingInventories.Feb)}}</td>
            <td :class="postData.year==year&&month==3?'bgColorFDF1F4':''">{{$commonJs.numFixed(item.EndingInventories.Mar)}}</td>
            <td :class="postData.year==year&&month==4?'bgColorFDF1F4':''">{{$commonJs.numFixed(item.EndingInventories.Apr)}}</td>
            <td :class="postData.year==year&&month==5?'bgColorFDF1F4':''">{{$commonJs.numFixed(item.EndingInventories.May)}}</td>
            <td :class="postData.year==year&&month==6?'bgColorFDF1F4':''">{{$commonJs.numFixed(item.EndingInventories.Jun)}}</td>
            <td :class="postData.year==year&&month==7?'bgColorFDF1F4':''">{{$commonJs.numFixed(item.EndingInventories.Jul)}}</td>
            <td :class="postData.year==year&&month==8?'bgColorFDF1F4':''">{{$commonJs.numFixed(item.EndingInventories.Aug)}}</td>
            <td :class="postData.year==year&&month==9?'bgColorFDF1F4':''">{{$commonJs.numFixed(item.EndingInventories.Sep)}}</td>
            <td :class="postData.year==year&&month==10?'bgColorFDF1F4':''">{{$commonJs.numFixed(item.EndingInventories.Oct)}}</td>
            <td :class="postData.year==year&&month==11?'bgColorFDF1F4':''">{{$commonJs.numFixed(item.EndingInventories.Nov)}}</td>
            <td :class="postData.year==year&&month==12?'bgColorFDF1F4':''">{{$commonJs.numFixed(item.EndingInventories.Dec)}}</td>
          </tr>
          <tr class="f_w">
            <td></td>
            <td>Months Of Coverages</td>
            <td class="salesBorder">
            <!--{{$commonJs.numFixed(item.MonthsOfCoverage.AnnutalTotal)}}-->
            </td>
            <td>{{$commonJs.numFixed(item.MonthsOfCoverage.Jan, 1)}}</td>
            <td>{{$commonJs.numFixed(item.MonthsOfCoverage.Feb, 1)}}</td>
            <td>{{$commonJs.numFixed(item.MonthsOfCoverage.Mar, 1)}}</td>
            <td>{{$commonJs.numFixed(item.MonthsOfCoverage.Apr, 1)}}</td>
            <td>{{$commonJs.numFixed(item.MonthsOfCoverage.May, 1)}}</td>
            <td>{{$commonJs.numFixed(item.MonthsOfCoverage.Jun, 1)}}</td>
            <td>{{$commonJs.numFixed(item.MonthsOfCoverage.Jul, 1)}}</td>
            <td>{{$commonJs.numFixed(item.MonthsOfCoverage.Aug, 1)}}</td>
            <td>{{$commonJs.numFixed(item.MonthsOfCoverage.Sep, 1)}}</td>
            <td>{{$commonJs.numFixed(item.MonthsOfCoverage.Oct, 1)}}</td>
            <td>{{$commonJs.numFixed(item.MonthsOfCoverage.Nov, 1)}}</td>
            <td>{{$commonJs.numFixed(item.MonthsOfCoverage.Dec, 1)}}</td>
          </tr>
        </tbody>
        <tbody v-if="(!mktData)||(!mktData.ShipmentInfoModelList)||mktData.ShipmentInfoModelList.length==0">
          <tr>
            <td colspan="16" class="t_c colorGray bot_bottom">{{$t('common.noData')}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div style="position: relative;height: 1px;"></div>
    <div class="chartArea" :class="showChartFlag?(showOtherChartFlag?'showOtherChart':'show'):'hide'">
      <button class="chartButton" @click="showChart()">{{showChartFlag?$t('common.Hide'):$t('common.Expand')}}</button>
      <div v-if="postData.year&&postData.quartersOrMonths!=3" class="chartButton" style="left: 100px;border:none;color: #1E1E1E;">{{$t('common.Year')}}: {{postData.year}}</div>
      <div v-if="(postData.version=='PreSOP_Shipment'||postData.version=='SOP_Shipment')&&this.postData.quartersOrMonths!=3" class="otherChartButton" @click="showOtherChart()">{{showOtherChartFlag?"▼":"▲"}}</div>
      <div style="right:10px;position: absolute;top: 10px;">
        <button v-if="postData.version=='PreSOP_Shipment'||postData.version=='SOP_Shipment'" class="chartRightButton" :class="postData.quartersOrMonths==3?'redButton m_r_10':'cancelButtonRed m_r_10'" @click="changeQorM(3)">{{$t('common.ByYear')}}</button>
        <button v-if="postData.version=='SOP'||postData.version=='PreSOP_Shipment'||postData.version=='SOP_Shipment'" class="chartRightButton" :class="postData.quartersOrMonths==1?'redButton m_r_10':'cancelButtonRed m_r_10'" @click="changeQorM(1)">{{$t('common.ByQuarter')}}</button>
        <button v-if="postData.version=='SOP'||postData.version=='PreSOP_Shipment'||postData.version=='SOP_Shipment'" class="chartRightButton" :class="postData.quartersOrMonths==2?'redButton m_r_10':'cancelButtonRed m_r_10'" @click="changeQorM(2)">{{$t('common.ByMonth')}}</button>
      </div>
      <table v-if="postData.quartersOrMonths!=3" class="chartTable">
        <tr>
          <td style="position: relative" class="f_w" @click="showInfo('YTD')">YTD <i class="icon iconfont icon-info"></i>
            <div v-if="canEditMonth==12" v-show="showInfoFlag=='YTD'&&canEditMonth==month" class="info-block">{{$t('common.YTDInfo', {'year': canEditYear, 'month': $t('common.'+$commonJs.getMonthTh(canEditMonth)+'M')})}}</div>
            <div v-else v-show="showInfoFlag=='YTD'" class="info-block">{{$t('common.YTDInfo', {'year': canEditYear, 'month': $t('common.'+$commonJs.getMonthTh(canEditMonth)+'M')})}}</div>
          </td>
          <td>{{postData.year==year?$commonJs.numFixed(postData.version=='PreSOP_Shipment'||postData.version=='SOP_Shipment'?mktData.ShipmentYTD:chartData.YTD):'— —'}}</td>
        </tr>
        <tr>
          <td style="position: relative" class="f_w" @click="showInfo('YTG')">YTG <i class="icon iconfont icon-info"></i>
            <div v-if="canEditMonth==12" v-show="showInfoFlag=='YTG'&&canEditMonth!=month" class="info-block">{{$t('common.YTGInfo', {'year': canEditMonth==12?(canEditYear+1):canEditYear, 'month': $t('common.'+$commonJs.getMonthTh(canEditMonth+1)+'M')})}}</div>
            <div v-else v-show="showInfoFlag=='YTG'" class="info-block">{{$t('common.YTGInfo', {'year': canEditMonth==12?(canEditYear+1):canEditYear, 'month': $t('common.'+$commonJs.getMonthTh(canEditMonth+1)+'M')})}}</div>
          </td>
          <td>{{postData.year==year?$commonJs.numFixed(postData.version=='PreSOP_Shipment'||postData.version=='SOP_Shipment'?mktData.ShipmentYTG:chartData.YTG):'— —'}}</td>
        </tr>
        <tr v-if="(postData.version=='SOP'||postData.version=='PreSOP_Shipment'||postData.version=='SOP_Shipment')&&legendSelt[item.title]&&postData.quartersOrMonths==2" :style="'color:'+getColor(index)" class="f_w" v-for="(item, index) in chartTableData" :key="index">
          <td>{{item.title}}</td>
          <td>{{item.value==0?'-':$commonJs.numFixed(item.value)}}</td>
        </tr>
      </table>
      <table v-else class="chartTable" style="width: 280px;">
        <tr v-if="legendSelt[item.title]||index==0" :style="index==0?'background:#FDF1F4':'color:'+getColor(index-1)" class="f_w" v-for="(item, index) in chartTableData" :key="index">
          <td>{{item.title}}</td>
          <td v-for="(subItem,i) in item.value" :key="i">{{index==0?subItem:$commonJs.numFixed(subItem)}}{{item.unit}}</td>
        </tr>
      </table>
      <div id="mktCharts" :style="(postData.version=='PreSOP_Shipment'||postData.version=='SOP_Shipment')&&showOtherChartFlag?'border-bottom: 1px dashed #999;':''" :class="postData.version=='SOP'||postData.version=='PreSOP_Shipment'||postData.version=='SOP_Shipment'?'sopChart':''"></div>
      <div style="position: relative;height:170px;top: 60px;">
        <table class="chartTable" style="top: 10px;">
          <tr>
            <td style="position: relative" class="f_w" @click="showInfo('YTD1')">YTD <i class="icon iconfont icon-info"></i>
              <div v-if="canEditMonth==12" v-show="showInfoFlag=='YTD1'&&canEditMonth==month" class="info-block">{{$t('common.YTDInfo', {'year': canEditYear, 'month': $t('common.'+$commonJs.getMonthTh(canEditMonth)+'M')})}}</div>
              <div v-else v-show="showInfoFlag=='YTD1'" class="info-block">{{$t('common.YTDInfo', {'year': canEditYear, 'month': $t('common.'+$commonJs.getMonthTh(canEditMonth)+'M')})}}</div>
            </td>
            <td>{{postData.year==year?$commonJs.numFixed(secondChartData.YTD):'— —'}}</td>
          </tr>
          <tr>
            <td style="position: relative" class="f_w" @click="showInfo('YTG1')">YTG <i class="icon iconfont icon-info"></i>
              <div v-if="canEditMonth==12" v-show="showInfoFlag=='YTG1'&&canEditMonth!=month" class="info-block">{{$t('common.YTGInfo', {'year': canEditMonth==12?(canEditYear+1):canEditYear, 'month': $t('common.'+$commonJs.getMonthTh(canEditMonth+1)+'M')})}}</div>
              <div v-else v-show="showInfoFlag=='YTG1'" class="info-block">{{$t('common.YTGInfo', {'year': canEditMonth==12?(canEditYear+1):canEditYear, 'month': $t('common.'+$commonJs.getMonthTh(canEditMonth+1)+'M')})}}</div>
            </td>
            <td>{{postData.year==year?$commonJs.numFixed(secondChartData.YTG):'— —'}}</td>
          </tr>
          <tr v-if="(postData.version=='SOP'||postData.version=='PreSOP_Shipment'||postData.version=='SOP_Shipment')&&legendSelt[item.title]&&postData.quartersOrMonths==2" :style="'color:'+getColor(index)" class="f_w" v-for="(item, index) in secondChartTableData" :key="index">
            <td>{{item.title}}</td>
            <td>{{item.value==0?'-':$commonJs.numFixed(item.value)}}</td>
          </tr>
        </table>
        <div id="secondCharts" style="height: 170px;"></div>
      </div>
    </div>
    <dialogArea :show="showDialog" :width="'90%'" @cancel="salesDialogCancel" :title="'Sales' + $t('common.Version')">
      <div slot="content">
        <router-view v-if="isRouterMktSales"></router-view>
      </div>
      <div slot="foter"></div>
    </dialogArea>
    <dialogArea :show="showInstructionDialog" :width="'75%'" @cancel="instructionDialogCancel" :title="$t('common.Instruction')">
      <div slot="content">
        <!-- <img src="@/assets/MKTInstructionImg20210304.jpg" style="width: 100%;"> -->
        <!-- <img :src="'/MKTInstructionImg.jpg?t='+new Date().getTime()" style="width: 100%;"> -->
        <h1 class="colorRed" style="font-weight: 600;">数据逻辑说明</h1>
        <div class="divider divider--horizontal">
          <!-- <div class="divider__text is-left">数据逻辑说明</div> -->
        </div>
        <table cellspacing="0" class="allTable" style="table-layout: fixed;">
          <thead>
            <tr style="font-size: 11pt;">
              <th>{{$t('MKTDescription.Group')}}</th>
              <!-- <th>{{$t('MKTDescription.Subgroup')}}</th> -->
              <th>{{$t('MKTDescription.MainContant')}}</th>
              <th>{{$t('MKTDescription.HistoryDataSource')}}</th>
              <th>{{$t('MKTDescription.CurrentMonthAndNextDataLogical')}}</th>
            </tr>
          </thead>
          <tbody>
            <tr class="colorRed f_w" >
              <td class="c_p">全国汇总</td><!-- {{$t('common.AllTotal')}} -->
              <!-- <td class="c_p">全国</td>{{$t('common.Nationwide')}} -->
              <td>所有渠道实际/预测汇总</td>
              <td>全国所有渠道实际</td>
              <td>汇总各大类的预测总值</td>
            </tr>
            <tr class="f_w" >
              <!-- <td class="c_p" rowspan="2" style="vertical-align : middle;">销售团队</td>{{$t('common.AllTotal')}} -->
              <td class="c_p">全国预估</td><!-- {{$t('common.Nationwide')}} -->
              <td>所有渠道预估汇总</td>
              <td>来自CODI上传预估</td>
              <td>来自CODI上传预估</td>
            </tr>
            <tr class="f_w" >
              <td class="c_p">全国预测</td><!-- {{$t('common.Nationwide')}} -->
              <td>所有渠道实际或预测</td>
              <td>全国所有渠道实际</td>
              <td>上一轮S8OP提交的预测</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div slot="foter"></div>
    </dialogArea>
    <dialogArea v-if="postData.version!='PreSOP_Shipment'&&postData.version!='SOP_Shipment'" :show="showSubmitDialog" :width="'90%'" @cancel="submitCancel" @confirm="submitConfirm" :title="$t('common.Preview')">
      <div slot="content">
        <!--<div style="text-align: center;font-size: 16px;margin: 40px 0;">{{$t('common.MktSubmitMsg')}}</div>-->
        <table class="dialogTable" cellspacing="0">
          <thead>
          <tr>
            <th>{{$t('common.Year')}}</th>
            <th>{{$t('common.AnnualTotal')}}</th>
            <th>{{$t('common.1M')}}</th>
            <th>{{$t('common.2M')}}</th>
            <th>{{$t('common.3M')}}</th>
            <th>{{$t('common.4M')}}</th>
            <th>{{$t('common.5M')}}</th>
            <th>{{$t('common.6M')}}</th>
            <th>{{$t('common.7M')}}</th>
            <th>{{$t('common.8M')}}</th>
            <th>{{$t('common.9M')}}</th>
            <th>{{$t('common.10M')}}</th>
            <th>{{$t('common.11M')}}</th>
            <th>{{$t('common.12M')}}</th>
          </tr>
          </thead>
          <tbody>
          <tr :key="index" v-for="(item, index) in mktPrevData">
            <td class="f_w">{{item.Year}}</td>
            <td class="f_w">{{$commonJs.numFixed(item.AnnutalTotal)}}</td>
            <td>{{$commonJs.numFixed(item.January)}}</td>
            <td>{{$commonJs.numFixed(item.February)}}</td>
            <td>{{$commonJs.numFixed(item.March)}}</td>
            <td>{{$commonJs.numFixed(item.April)}}</td>
            <td>{{$commonJs.numFixed(item.May)}}</td>
            <td>{{$commonJs.numFixed(item.June)}}</td>
            <td>{{$commonJs.numFixed(item.July)}}</td>
            <td>{{$commonJs.numFixed(item.August)}}</td>
            <td>{{$commonJs.numFixed(item.September)}}</td>
            <td>{{$commonJs.numFixed(item.October)}}</td>
            <td>{{$commonJs.numFixed(item.November)}}</td>
            <td>{{$commonJs.numFixed(item.December)}}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div v-if="postData.version!='MKT'" slot="foter"></div>
    </dialogArea>
    <dialogArea v-else :show="showSubmitDialog" :width="'90%'" @cancel="submitCancel" @confirm="submitShipmentConfirm" :title="$t('common.Preview')">
      <div slot="content">
        <div style="text-align: center;font-size: 16px;margin: 20px 0;" class="colorRed">{{$t('common.versionwillbelocked')}}</div>
        <div class="d_flex m_b_20" style="justify-content: space-evenly;">
          <div class="d_flex">{{$t('common.Brand')}}：<span class="colorRed f_w">{{brandName}}</span></div>
          <div class="d_flex">{{$t('common.Version')}}：<span class="colorRed f_w">{{year}}{{month>9?month:('0'+month)}}</span></div>
          <div class="d_flex">{{$t('common.Forecast')}}：<span class="colorRed f_w">{{postData.version=='PreSOP_Shipment'?'Pre-S&OP':'S&OP'}}</span></div>
          <div class="d_flex">{{$t('common.MOH')}}：<span class="colorRed f_w">{{postData.MOHMonthNum==3?$t('common.Future3Months'):$t('common.Future6Months')}}</span></div>
        </div>
        <table class="dialogTable" cellspacing="0" style="width: 100%;">
          <thead>
          <tr class="bgColorFDF1F4">
            <th>{{$t('common.Year')}}</th>
            <th></th>
            <th>{{$t('common.AnnualTotal')}}</th>
            <th>{{$t('common.1M')}}</th>
            <th>{{$t('common.2M')}}</th>
            <th>{{$t('common.3M')}}</th>
            <th>{{$t('common.4M')}}</th>
            <th>{{$t('common.5M')}}</th>
            <th>{{$t('common.6M')}}</th>
            <th>{{$t('common.7M')}}</th>
            <th>{{$t('common.8M')}}</th>
            <th>{{$t('common.9M')}}</th>
            <th>{{$t('common.10M')}}</th>
            <th>{{$t('common.11M')}}</th>
            <th>{{$t('common.12M')}}</th>
          </tr>
          </thead>
          <tbody :key="index" v-for="(item, index) in mktPrevData.PreviewList" :style="index>0?'border-top-style:double;border-top-color:#E3E3E3;':''">
            <tr v-if="item.MKTForecast" class="f_w" style="background: #F8F8F8;">
              <td rowspan="4">{{item.Year}}</td>
              <td class="tdRowBreak">In MKT Biz Forecast</td>
              <td>{{$commonJs.numFixed(item.MKTForecast.AnnutalTotal)}}</td>
              <td>{{$commonJs.numFixed(item.MKTForecast.Jan)}}</td>
              <td>{{$commonJs.numFixed(item.MKTForecast.Feb)}}</td>
              <td>{{$commonJs.numFixed(item.MKTForecast.Mar)}}</td>
              <td>{{$commonJs.numFixed(item.MKTForecast.Apr)}}</td>
              <td>{{$commonJs.numFixed(item.MKTForecast.May)}}</td>
              <td>{{$commonJs.numFixed(item.MKTForecast.Jun)}}</td>
              <td>{{$commonJs.numFixed(item.MKTForecast.Jul)}}</td>
              <td>{{$commonJs.numFixed(item.MKTForecast.Aug)}}</td>
              <td>{{$commonJs.numFixed(item.MKTForecast.Sep)}}</td>
              <td>{{$commonJs.numFixed(item.MKTForecast.Oct)}}</td>
              <td>{{$commonJs.numFixed(item.MKTForecast.Nov)}}</td>
              <td>{{$commonJs.numFixed(item.MKTForecast.Dec)}}</td>
            </tr>
            <tr v-if="item.CurrentMonthShipmentPlan" style="background: #EFF7FE;">
              <td class="tdRowBreak">{{$t('common.CurrentShipmentplan')}}</td>
              <td>{{$commonJs.numFixed(item.CurrentMonthShipmentPlan.AnnutalTotal)}}</td>
              <td>{{$commonJs.numFixed(item.CurrentMonthShipmentPlan.Jan)}}</td>
              <td>{{$commonJs.numFixed(item.CurrentMonthShipmentPlan.Feb)}}</td>
              <td>{{$commonJs.numFixed(item.CurrentMonthShipmentPlan.Mar)}}</td>
              <td>{{$commonJs.numFixed(item.CurrentMonthShipmentPlan.Apr)}}</td>
              <td>{{$commonJs.numFixed(item.CurrentMonthShipmentPlan.May)}}</td>
              <td>{{$commonJs.numFixed(item.CurrentMonthShipmentPlan.Jun)}}</td>
              <td>{{$commonJs.numFixed(item.CurrentMonthShipmentPlan.Jul)}}</td>
              <td>{{$commonJs.numFixed(item.CurrentMonthShipmentPlan.Aug)}}</td>
              <td>{{$commonJs.numFixed(item.CurrentMonthShipmentPlan.Sep)}}</td>
              <td>{{$commonJs.numFixed(item.CurrentMonthShipmentPlan.Oct)}}</td>
              <td>{{$commonJs.numFixed(item.CurrentMonthShipmentPlan.Nov)}}</td>
              <td>{{$commonJs.numFixed(item.CurrentMonthShipmentPlan.Dec)}}</td>
            </tr>
            <tr v-if="item.EndingInventories" style="background: #FEF8EE;">
              <td class="tdRowBreak">Ending Inventories</td>
              <td>
<!--                {{$commonJs.numFixed(item.EndingInventories.AnnutalTotal)}}-->
              </td>
              <td>{{$commonJs.numFixed(item.EndingInventories.Jan)}}</td>
              <td>{{$commonJs.numFixed(item.EndingInventories.Feb)}}</td>
              <td>{{$commonJs.numFixed(item.EndingInventories.Mar)}}</td>
              <td>{{$commonJs.numFixed(item.EndingInventories.Apr)}}</td>
              <td>{{$commonJs.numFixed(item.EndingInventories.May)}}</td>
              <td>{{$commonJs.numFixed(item.EndingInventories.Jun)}}</td>
              <td>{{$commonJs.numFixed(item.EndingInventories.Jul)}}</td>
              <td>{{$commonJs.numFixed(item.EndingInventories.Aug)}}</td>
              <td>{{$commonJs.numFixed(item.EndingInventories.Sep)}}</td>
              <td>{{$commonJs.numFixed(item.EndingInventories.Oct)}}</td>
              <td>{{$commonJs.numFixed(item.EndingInventories.Nov)}}</td>
              <td>{{$commonJs.numFixed(item.EndingInventories.Dec)}}</td>
            </tr>
            <tr v-if="item.MonthsOfCoverage" style="background: #FEF8EE;">
              <td class="tdRowBreak">Months Of Coverages</td>
              <td>
<!--                {{$commonJs.numFixed(item.MonthsOfCoverage.AnnutalTotal)}}-->
              </td>
              <td>{{$commonJs.numFixed(item.MonthsOfCoverage.Jan,1)}}</td>
              <td>{{$commonJs.numFixed(item.MonthsOfCoverage.Feb,1)}}</td>
              <td>{{$commonJs.numFixed(item.MonthsOfCoverage.Mar,1)}}</td>
              <td>{{$commonJs.numFixed(item.MonthsOfCoverage.Apr,1)}}</td>
              <td>{{$commonJs.numFixed(item.MonthsOfCoverage.May,1)}}</td>
              <td>{{$commonJs.numFixed(item.MonthsOfCoverage.Jun,1)}}</td>
              <td>{{$commonJs.numFixed(item.MonthsOfCoverage.Jul,1)}}</td>
              <td>{{$commonJs.numFixed(item.MonthsOfCoverage.Aug,1)}}</td>
              <td>{{$commonJs.numFixed(item.MonthsOfCoverage.Sep,1)}}</td>
              <td>{{$commonJs.numFixed(item.MonthsOfCoverage.Oct,1)}}</td>
              <td>{{$commonJs.numFixed(item.MonthsOfCoverage.Nov,1)}}</td>
              <td>{{$commonJs.numFixed(item.MonthsOfCoverage.Dec,1)}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </dialogArea>
  </div>
</template>

<script>
import echarts from 'echarts'
let infoTimeOut
export default {
  // 组件
  name: 'mktReport',
  data () {
    return {
      height: 0,
      postData: {
        brandCode: '',
        year: '',
        version: '',
        quartersOrMonths: 1,
        groupId: '',
        MOHMonthNum: 3,
        LastEndingInventoryInput: 0
      },
      mohSelectData: [
        {Code: 3, Name: this.$t('common.Future3Months')},
        {Code: 6, Name: this.$t('common.Future6Months')},
        {Code: 1, Name: this.$t('common.FutureMonthsRounding')}
      ],
      hideBtn: false,
      brandList: [],
      moduleList: [],
      yearList: [],
      mktData: false,
      mktPrevData: [],
      chartData: [],
      secondChartData: [],
      legendSelt: {},
      showChartFlag: true,
      showOtherChartFlag: false,
      expendRowList: [],
      expendRowCode: false,
      dialogData: false,
      showDialog: false,
      showSubmitDialog: false,
      showInstructionDialog: false,
      isRouterMktSales: false,
      chartTableData: [],
      secondChartTableData: [],
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      canEditYear: 0,
      canEditMonth: 0,
      mainScrollTop: 215,
      showInfoFlag: false,
      isAlreadyEdit: false
    }
  },
  beforeCreate () {
    this.$parent.topName = 'Forecast'
  },
  created () {
    this.getBrandList()
  },
  destroyed () {
    window.removeEventListener('resize', this.resizeTable)
  },
  mounted () {
    window.addEventListener('resize', this.resizeTable)
    this.$nextTick(() => {
      this.mainScrollTop = document.getElementById('mainFixed2').offsetHeight
      document.body.scrollTop = document.documentElement.scrollTop = 0
      this.chart = echarts.init(document.getElementById('mktCharts'))
      this.secondChart = echarts.init(document.getElementById('secondCharts'))
      this.chart.on('legendselectchanged', obj => {
        if (this.legendSelt[obj.name]) {
          this.$set(this.legendSelt, obj.name, false)
        } else {
          this.$set(this.legendSelt, obj.name, true)
        }
      })
      this.secondChart.on('legendselectchanged', obj => {
        if (this.legendSelt[obj.name]) {
          this.$set(this.legendSelt, obj.name, false)
        } else {
          this.$set(this.legendSelt, obj.name, true)
        }
      })
    })
  },
  methods: {
    alreadyEdit () {
      this.isAlreadyEdit = true
    },
    resizeTable () {
      this.mainScrollTop = document.getElementById('mainFixed2').offsetHeight
      this.chart.resize()
      this.secondChart.resize()
    },
    changeVersion (data) {
      let isGo = true
      if (this.isAlreadyEdit) {
        isGo = confirm(this.$t('common.NoSaveRefresh'))
      }
      if (isGo) {
        this.year = data.Year
        this.month = data.Month
        this.yearList = [{Code: this.year, Name: this.year}, {Code: Number(this.year) + 1, Name: Number(this.year) + 1}, {Code: Number(this.year) + 2, Name: Number(this.year) + 2}]
        if (this.postData.version !== data.Code) {
          this.postData.version = data.Code
          localStorage.channelCodeKey = data.Code
          if (this.postData.version !== 'PreSOP_Shipment' && this.postData.version !== 'SOP_Shipment') {
            this.showOtherChartFlag = false
            if (this.postData.quartersOrMonths === 3) {
              this.postData.quartersOrMonths = 1
            }
            this.$parent.topName = 'Forecast'
            this.mktData = false
            this.postData.year = this.year
            this.getMktList()
          } else {
            this.$parent.topName = 'Shipment'
            this.mktData = false
            this.postData.year = this.year
            this.getShipmentList()
          }
        }
      }
    },
    getBrandList () {
      this.$axiox.get(`/api/v1/admin/marketing/brand?yearMonth=&year=${this.year}`).then(msg => {
        this.brandList = msg.data || []
        let seltIndex = 0
        if (this.brandList && this.brandList.length > 0) {
          if (localStorage.brandCodeKey && localStorage.brandCodeKey !== '') {
            this.postData.brandCode = localStorage.brandCodeKey
          }
          this.brandList.forEach((e, i) => {
            if (e.Status || e.Status === this.$t('common.Draft')) {
              this.brandList[i].state = true
            } else {
              this.brandList[i].state = false
            }
            if (this.postData.brandCode === e.Code) {
              seltIndex = i
            }
          })
          this.postData.brandCode = this.brandList[seltIndex].Code
          if (this.postData.brandCode.indexOf('_') !== -1) {
            this.hideBtn = true
          } else {
            this.hideBtn = false
          }
          localStorage.brandCodeKey = this.postData.brandCode
          this.brandName = this.brandList[seltIndex].Name
          this.canEditYear = this.brandList[seltIndex].Year
          this.canEditMonth = this.brandList[seltIndex].Month
          this.getChannelList()
        }
      })
    },
    showInfo (type) {
      if (this.showInfoFlag) {
        clearTimeout(infoTimeOut)
      }
      if (this.showInfoFlag !== type) {
        this.showInfoFlag = type
        infoTimeOut = setTimeout(() => {
          this.showInfoFlag = false
        }, 3000)
      }
    },
    getChannelList () {
      this.$axiox.get('/api/v1/admin/marketing/channel?brandCode=' + this.postData.brandCode).then(msg => {
        this.moduleList = msg.data || []
        let seltIndex = false
        if (this.moduleList && this.moduleList.length > 0) {
          if (localStorage.channelCodeKey && localStorage.channelCodeKey !== '') {
            this.postData.version = localStorage.channelCodeKey
            this.moduleList.forEach((item, i) => {
              if (this.postData.version === item.Code && item.Enable && item.Code !== 'Sales') {
                this.postData.version = localStorage.channelCodeKey
                this.year = item.Year
                this.month = item.Month
                seltIndex = true
              }
            })
          }
          if (!seltIndex) {
            for (let item of this.moduleList) {
              if (item.Enable && item.Code !== 'Sales') {
                this.postData.version = item.Code
                localStorage.channelCodeKey = item.Code
                this.year = item.Year
                this.month = item.Month
                break
              }
            }
          }
          this.postData.year = this.year
          this.yearList = [{Code: this.year, Name: this.year}, {Code: Number(this.year) + 1, Name: Number(this.year) + 1}, {Code: Number(this.year) + 2, Name: Number(this.year) + 2}]
          if (this.postData.version !== 'PreSOP_Shipment' && this.postData.version !== 'SOP_Shipment') {
            this.mktData = false
            this.getMktList()
          } else {
            this.mktData = false
            this.getShipmentList()
          }
        }
      })
    },
    getMktList () {
      this.chart.clear()
      this.secondChart.clear()
      this.isAlreadyEdit = false
      let data = JSON.parse(JSON.stringify(this.postData))
      let url = this.$commonJs.returnQuery('/api/v1/admin/marketing', data)
      this.$axiox.get(url).then(msg => {
        this.mktData = msg.data || false
        let year = new Date().getFullYear()
        let month = new Date().getMonth()
        if (month === 0) {
          year--
          month = 12
        }
        this.$nextTick(() => {
          console.log(this.$refs.totalTr.children)
          // 当前年月+3月，判断是否是预测和实际标志显示
          const tdContent = this.$refs.totalTr.children[month + 3].innerHTML
          if (tdContent !== '— —' && year === this.postData.year) {
            let d = document.createElement('div')
            /* isForecast
             * 当前年 = 可编辑年 && 当前月小于可编辑月：true
             * 当前年小于可编辑年：true
             */
            if (this.isForecast(year, month)) {
              d.className = 'is_forecast colorA'
              d.append('A')
            } else {
              d.className = 'is_forecast colorF'
              d.append('F')
            }
            this.$refs.totalTr.children[month + 3].appendChild(d)
          }
          this.mainScrollTop = document.getElementById('mainFixed2').offsetHeight
          document.body.scrollTop = document.documentElement.scrollTop = 0
        })
        this.getMktChartData()
      })
    },
    getShipmentList () {
      this.chart.clear()
      this.secondChart.clear()
      this.isAlreadyEdit = false
      let data = JSON.parse(JSON.stringify(this.postData))
      let url = this.$commonJs.returnQuery('/api/v1/admin/shipment', data)
      this.$axiox.get(url).then(msg => {
        this.mktData = msg.data || false
        if (this.mktData && this.mktData.ShipmentInfoModelList && this.mktData.ShipmentInfoModelList.length > 0) {
          this.mktData.ShipmentInfoModelList.forEach(item => {
            if (item.Year === this.year) {
              this.mktData.IsEditable = item.IsEditable
              this.mktData.ShipmentYTD = item.ShipmentYTD
              this.mktData.ShipmentYTG = item.ShipmentYTG
              if (item.EndingInventories && item.EndingInventories[this.getMonthKey(this.month)]) {
                this.postData.LastEndingInventoryInput = item.EndingInventories[this.getMonthKey(this.month)]
              } else {
                item.EndingInventories[this.getMonthKey(this.month)] = 0
                this.postData.LastEndingInventoryInput = 0
              }
            }
          })
        }
        this.$nextTick(() => {
          this.mainScrollTop = document.getElementById('mainFixed2').offsetHeight
          document.body.scrollTop = document.documentElement.scrollTop = 0
        })
        this.getMktChartData()
      })
    },
    expendRow (territoryCode) {
      if (this.expendRowCode && this.expendRowCode === territoryCode) {
        this.expendRowCode = false
      } else {
        this.expendRowCode = territoryCode
      }
    },
    getMktChartData () {
      this.chart.clear()
      this.secondChart.clear()
      let data = JSON.parse(JSON.stringify(this.postData))
      if (this.postData.version !== 'SOP') {
        if (this.postData.version !== 'PreSOP_Shipment' && this.postData.version !== 'SOP_Shipment') {
          let url = this.$commonJs.returnQuery('/api/v1/admin/marketing/chartData', data)
          this.$axiox.get(url).then(msg => {
            if (msg.data) {
              this.chartData = msg.data
              let datas = {}
              let qList = []
              let seriesList = []
              qList.push('Q1')
              seriesList.push(msg.data.Q1 || 0)
              qList.push('Q2')
              seriesList.push(msg.data.Q2 || 0)
              qList.push('Q3')
              seriesList.push(msg.data.Q3 || 0)
              qList.push('Q4')
              seriesList.push(msg.data.Q4 || 0)
              datas.qList = qList
              datas.seriesList = seriesList
              this.$nextTick(() => {
                this.getOptionData(datas)
              })
            }
          })
        } else { // shepment chart data
          if (this.mktData && this.mktData.ShipmentInfoModelList && this.mktData.ShipmentInfoModelList.length > 0) {
            if (this.postData.quartersOrMonths === 2) { // 按月份
              let datas = {}
              let legendList = []
              let monthList = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
              let seriesList = []
              let chartTableData = []
              this.mktData.ShipmentInfoModelList.forEach(item => {
                if (this.postData.year === item.Year) {
                  if (item.EndingInventories) {
                    let dataList = []
                    dataList.push(item.EndingInventories.Jan)
                    dataList.push(item.EndingInventories.Feb)
                    dataList.push(item.EndingInventories.Mar)
                    dataList.push(item.EndingInventories.Apr)
                    dataList.push(item.EndingInventories.May)
                    dataList.push(item.EndingInventories.Jun)
                    dataList.push(item.EndingInventories.Jul)
                    dataList.push(item.EndingInventories.Aug)
                    dataList.push(item.EndingInventories.Sep)
                    dataList.push(item.EndingInventories.Oct)
                    dataList.push(item.EndingInventories.Nov)
                    dataList.push(item.EndingInventories.Dec)
                    if (!this.legendSelt.hasOwnProperty('Ending Inventories')) {
                      this.$set(this.legendSelt, 'Ending Inventories', true)
                    }
                    legendList.push('Ending Inventories')
                    seriesList.push({
                      name: 'Ending Inventories',
                      yAxisIndex: 0,
                      barMaxWidth: 20,
                      data: dataList,
                      type: 'bar'
                    })
                    // chartTableData.push({'title': 'Ending Inventories', 'value': item.EndingInventories.AnnutalTotal || 0})
                  }
                  if (item.CurrentMonthShipmentPlan) {
                    let dataList = []
                    dataList.push(item.CurrentMonthShipmentPlan.Jan)
                    dataList.push(item.CurrentMonthShipmentPlan.Feb)
                    dataList.push(item.CurrentMonthShipmentPlan.Mar)
                    dataList.push(item.CurrentMonthShipmentPlan.Apr)
                    dataList.push(item.CurrentMonthShipmentPlan.May)
                    dataList.push(item.CurrentMonthShipmentPlan.Jun)
                    dataList.push(item.CurrentMonthShipmentPlan.Jul)
                    dataList.push(item.CurrentMonthShipmentPlan.Aug)
                    dataList.push(item.CurrentMonthShipmentPlan.Sep)
                    dataList.push(item.CurrentMonthShipmentPlan.Oct)
                    dataList.push(item.CurrentMonthShipmentPlan.Nov)
                    dataList.push(item.CurrentMonthShipmentPlan.Dec)
                    if (!this.legendSelt.hasOwnProperty('Shipment Plan')) {
                      this.$set(this.legendSelt, 'Shipment Plan', true)
                    }
                    legendList.push('Shipment Plan')
                    seriesList.push({
                      name: 'Shipment Plan',
                      barMaxWidth: 20,
                      yAxisIndex: 0,
                      data: dataList,
                      type: 'bar'
                    })
                    chartTableData.push({'title': 'Shipment Plan', 'value': item.CurrentMonthShipmentPlan.AnnutalTotal || 0})
                  }
                  if (item.MonthsOfCoverage) {
                    let dataList = []
                    dataList.push(item.MonthsOfCoverage.Jan)
                    dataList.push(item.MonthsOfCoverage.Feb)
                    dataList.push(item.MonthsOfCoverage.Mar)
                    dataList.push(item.MonthsOfCoverage.Apr)
                    dataList.push(item.MonthsOfCoverage.May)
                    dataList.push(item.MonthsOfCoverage.Jun)
                    dataList.push(item.MonthsOfCoverage.Jul)
                    dataList.push(item.MonthsOfCoverage.Aug)
                    dataList.push(item.MonthsOfCoverage.Sep)
                    dataList.push(item.MonthsOfCoverage.Oct)
                    dataList.push(item.MonthsOfCoverage.Nov)
                    dataList.push(item.MonthsOfCoverage.Dec)
                    if (!this.legendSelt.hasOwnProperty('Months Of Coverages')) {
                      this.$set(this.legendSelt, 'Months Of Coverages', true)
                    }
                    legendList.push('Months Of Coverages')
                    seriesList.push({
                      name: 'Months Of Coverages',
                      yAxisIndex: 1,
                      data: dataList,
                      type: 'line'
                    })
                    // chartTableData.push({'title': 'Months Of Coverages', 'value': item.MonthsOfCoverage.AnnutalTotal || 0})
                  }
                }
              })
              this.chartTableData = chartTableData
              datas.legendList = legendList
              datas.monthList = monthList
              datas.seriesList = seriesList
              this.getShipmentOptionData(datas)
            } else if (this.postData.quartersOrMonths === 1) { // 按季度
              let datas = {}
              let legendList = []
              let monthList = []
              let seriesList = []
              let chartTableData = []
              let endingInventoriesList = []
              let currentMonthShipmentPlanList = []
              let monthsOfCoverageList = []
              this.mktData.ShipmentInfoModelList.forEach(item => {
                monthList.push(item.Year + '-Q1')
                monthList.push(item.Year + '-Q2')
                monthList.push(item.Year + '-Q3')
                monthList.push(item.Year + '-Q4')
                if (item.EndingInventories) {
                  endingInventoriesList.push(item.EndingInventories.FirstQuarter)
                  endingInventoriesList.push(item.EndingInventories.SecondQuarter)
                  endingInventoriesList.push(item.EndingInventories.ThirdQuarter)
                  endingInventoriesList.push(item.EndingInventories.FourthQuarter)
                  if (!this.legendSelt.hasOwnProperty('Ending Inventories')) {
                    this.$set(this.legendSelt, 'Ending Inventories', true)
                  }
                  // chartTableData.push({'title': 'Ending Inventories', 'value': item.EndingInventories.AnnutalTotal || 0})
                }
                if (item.CurrentMonthShipmentPlan) {
                  currentMonthShipmentPlanList.push(item.CurrentMonthShipmentPlan.FirstQuarter)
                  currentMonthShipmentPlanList.push(item.CurrentMonthShipmentPlan.SecondQuarter)
                  currentMonthShipmentPlanList.push(item.CurrentMonthShipmentPlan.ThirdQuarter)
                  currentMonthShipmentPlanList.push(item.CurrentMonthShipmentPlan.FourthQuarter)
                  if (!this.legendSelt.hasOwnProperty('Shipment Plan')) {
                    this.$set(this.legendSelt, 'Shipment Plan', true)
                  }
                  if (this.postData.year === item.Year) {
                    chartTableData.push({'title': 'Shipment Plan', 'value': item.CurrentMonthShipmentPlan.AnnutalTotal || 0})
                  }
                }
                if (item.MonthsOfCoverage) {
                  monthsOfCoverageList.push(item.MonthsOfCoverage.FirstQuarter)
                  monthsOfCoverageList.push(item.MonthsOfCoverage.SecondQuarter)
                  monthsOfCoverageList.push(item.MonthsOfCoverage.ThirdQuarter)
                  monthsOfCoverageList.push(item.MonthsOfCoverage.FourthQuarter)
                  if (!this.legendSelt.hasOwnProperty('Months Of Coverages')) {
                    this.$set(this.legendSelt, 'Months Of Coverages', true)
                  }
                  // chartTableData.push({'title': 'Months Of Coverages', 'value': item.MonthsOfCoverage.AnnutalTotal || 0})
                }
              })
              legendList.push('Ending Inventories')
              seriesList.push({
                name: 'Ending Inventories',
                yAxisIndex: 0,
                barMaxWidth: 20,
                data: endingInventoriesList,
                type: 'bar'
              })
              legendList.push('Shipment Plan')
              seriesList.push({
                name: 'Shipment Plan',
                barMaxWidth: 20,
                yAxisIndex: 0,
                data: currentMonthShipmentPlanList,
                type: 'bar'
              })
              legendList.push('Months Of Coverages')
              seriesList.push({
                name: 'Months Of Coverages',
                yAxisIndex: 1,
                data: monthsOfCoverageList,
                type: 'line'
              })
              this.chartTableData = chartTableData
              datas.legendList = legendList
              datas.monthList = monthList
              datas.seriesList = seriesList
              this.getShipmentOptionData(datas)
            } else { // 按年度
              let url = this.$commonJs.returnQuery('/api/v1/admin/shipment/chart', data)
              this.$axiox.get(url).then(msg => {
                if (msg.data && msg.data.length > 0) {
                  let datas = {}
                  let legendList = []
                  let monthList = []
                  let seriesList = []
                  let shipmentList = []
                  let fcstList = []
                  let fcstGrList = []
                  let chartTableData = []
                  msg.data.forEach((item, index) => {
                    monthList.push(item.Year + 'TTL')
                    if (item.LEData && item.LEData.length > 0) {
                      item.LEData.forEach(subItem => {
                        if (subItem.Scenario) {
                          if (!this.legendSelt.hasOwnProperty(subItem.Scenario)) {
                            this.$set(this.legendSelt, subItem.Scenario, true)
                          }
                          if (legendList.indexOf(subItem.Scenario) === -1) {
                            legendList.push(subItem.Scenario)
                            let arr = new Array(msg.data.length)
                            arr[index] = subItem.Value
                            seriesList.push({
                              name: subItem.Scenario,
                              barMaxWidth: 20,
                              yAxisIndex: 0,
                              data: arr,
                              type: 'bar'
                            })
                            chartTableData.push({'title': subItem.Scenario, 'value': arr})
                          } else {
                            seriesList.forEach(item => {
                              if (item.name === subItem.Scenario) {
                                item.data[index] = subItem.Value
                                chartTableData[legendList.indexOf(subItem.Scenario)].value[index] = subItem.Value
                              }
                            })
                          }
                        }
                      })
                    }
                    shipmentList.push(item.Shipment)
                    fcstList.push(item.Forecast)
                    fcstGrList.push(Math.round(item.ForecastGrowth * 100))
                  })
                  if (!this.legendSelt.hasOwnProperty('Shipment')) {
                    this.$set(this.legendSelt, 'Shipment', true)
                  }
                  if (!this.legendSelt.hasOwnProperty('Fcst')) {
                    this.$set(this.legendSelt, 'Fcst', true)
                  }
                  if (!this.legendSelt.hasOwnProperty('Fcst GR%')) {
                    this.$set(this.legendSelt, 'Fcst GR%', true)
                  }
                  legendList.push('Shipment')
                  chartTableData.push({'title': 'Shipment', 'value': shipmentList})
                  seriesList.push({
                    name: 'Shipment',
                    barMaxWidth: 20,
                    yAxisIndex: 0,
                    data: shipmentList,
                    type: 'bar'
                  })
                  legendList.push('Fcst')
                  chartTableData.push({'title': 'Fcst', 'value': fcstList})
                  seriesList.push({
                    name: 'Fcst',
                    barMaxWidth: 20,
                    yAxisIndex: 0,
                    data: fcstList,
                    type: 'bar'
                  })
                  legendList.push('Fcst GR%')
                  chartTableData.push({'title': 'Fcst GR%', 'value': fcstGrList, 'unit': '%'})
                  seriesList.push({
                    name: 'Fcst GR%',
                    yAxisIndex: 1,
                    data: fcstGrList,
                    type: 'line'
                  })
                  chartTableData.unshift({'title': '', 'value': monthList})
                  this.chartTableData = chartTableData
                  datas.legendList = legendList
                  datas.monthList = monthList
                  datas.seriesList = seriesList
                  this.getShipmentOptionDataByYear(datas)
                }
              })
            }
          }
          if (data.quartersOrMonths !== 3) {
            if (data.quartersOrMonths === 1 || data.quartersOrMonths === '1') {
              data.year = this.year
            }
            if (this.postData.version === 'PreSOP_Shipment') {
              data.channel = 'PreSOP'
            }
            let url = this.$commonJs.returnQuery('/api/v1/admin/chartdata/mkt/report', data)
            this.$axiox.get(url).then(msg => {
              if (msg.data) {
                this.secondChartData = msg.data.TableData || {}
              }
              if (msg.data && msg.data.ChartData) {
                let datas = {}
                let legendList = []
                let monthList = []
                let seriesList = []
                let chartTableData = []
                for (let key in msg.data.ChartData) {
                  if (monthList.length === 0) {
                    msg.data.ChartData[key].forEach((item, i) => {
                      monthList.push(item.YearMonth)
                    })
                  }
                  let dataList = []
                  let total = 0
                  if (msg.data.ChartData[key] && msg.data.ChartData[key].length > 0) {
                    msg.data.ChartData[key].forEach(val => {
                      dataList.push(val.Value)
                      total = Number(total + val.Value)
                    })
                  }
                  if (total !== 0) {
                    if (!this.legendSelt.hasOwnProperty(key)) {
                      this.$set(this.legendSelt, key, true)
                    }
                    legendList.push(key)
                    chartTableData.push({'title': key, 'value': total})
                    seriesList.push({
                      name: key,
                      data: dataList,
                      type: 'bar',
                      barMaxWidth: 10
                    })
                  }
                }
                this.secondChartTableData = chartTableData
                datas.legendList = legendList
                datas.monthList = monthList
                datas.seriesList = seriesList
                this.getSopOptionData(datas, true)
              }
            })
          }
        }
      } else {
        if (data.quartersOrMonths === 1 || data.quartersOrMonths === '1') {
          data.year = this.year
        }
        let url = this.$commonJs.returnQuery('/api/v1/admin/chartdata/mkt/report', data)
        this.$axiox.get(url).then(msg => {
          if (msg.data) {
            this.chartData = msg.data.TableData || {}
          }
          if (msg.data && msg.data.ChartData) {
            let datas = {}
            let legendList = []
            let monthList = []
            let seriesList = []
            let chartTableData = []
            for (let key in msg.data.ChartData) {
              if (monthList.length === 0) {
                msg.data.ChartData[key].forEach((item, i) => {
                  monthList.push(item.YearMonth)
                })
              }
              let dataList = []
              let total = 0
              if (msg.data.ChartData[key] && msg.data.ChartData[key].length > 0) {
                msg.data.ChartData[key].forEach(val => {
                  dataList.push(val.Value)
                  total = Number(total + val.Value)
                })
              }
              if (total !== 0) {
                if (!this.legendSelt.hasOwnProperty(key)) {
                  this.$set(this.legendSelt, key, true)
                }
                legendList.push(key)
                chartTableData.push({'title': key, 'value': total})
                seriesList.push({
                  name: key,
                  data: dataList,
                  type: 'bar',
                  barMaxWidth: 10
                })
              }
            }
            this.chartTableData = chartTableData
            datas.legendList = legendList
            datas.monthList = monthList
            datas.seriesList = seriesList
            this.getSopOptionData(datas)
          }
        })
      }
    },
    saveMktList (data) {
      this.$axiox.put('/api/v1/admin/marketing', data).then(msg => {
        this.$commonJs.alertTips({
          type: 'success',
          content: this.$t('common.SaveSuccess'),
          stayTime: 5
        })
        this.getMktList()
      })
    },
    saveAndRefresh () {
      let data = {}
      data.ShipmentMKTGroupModel = []
      data.CurrentMonthShipmentPlan = []
      data.lastEndingInventoryValue = this.postData.LastEndingInventoryInput
      data.version = this.postData.version
      data.brandCode = this.postData.brandCode
      this.mktData.ShipmentInfoModelList.forEach(item => {
        data.ShipmentMKTGroupModel.push(item.MKTForecast.ShipmentMKTGroupModel)
        data.CurrentMonthShipmentPlan.push(item.CurrentMonthShipmentPlan)
      })
      this.$axiox.put('/api/v1/admin/shipment', data).then(msg => {
        this.$commonJs.alertTips({
          type: 'success',
          content: this.$t('common.SaveSuccess'),
          stayTime: 5
        })
        this.mktData = false
        this.getShipmentList()
      })
    },
    submitData () {
      let data = JSON.parse(JSON.stringify(this.postData))
      this.$axiox.put('/api/v1/admin/marketing/submit', data).then(msg => {
        this.showSubmitDialog = false
        this.$commonJs.alertTips({
          type: 'success',
          content: this.$t('common.SubmitSuccess'),
          stayTime: 5
        })
        this.getMktList()
      })
    },
    downLoad () {
      let data = JSON.parse(JSON.stringify(this.postData))
      if (this.postData.version === 'SOP_Shipment') {
        let url = this.$commonJs.returnQuery('/api/v1/admin/shipment/export', data)
        this.$axiox.get(url).then(res => {
          location.href = res.data.FileURL
          this.$commonJs.alertTips({
            type: 'success',
            content: this.$t('common.ExportSuccess'),
            stayTime: 5
          })
        })
      } else {
        let url = this.$commonJs.returnQuery('/api/v1/admin/marketing/export', data)
        this.$axiox.get(url).then(res => {
          location.href = res.data.FileURL
          this.$commonJs.alertTips({
            type: 'success',
            content: this.$t('common.ExportSuccess'),
            stayTime: 5
          })
        })
      }
    },
    brandChange (data) {
      this.brandName = data.Name
      this.canEditYear = data.Year
      this.canEditMonth = data.Month
      this.expendRowCode = false
      this.postData.hospital = ''
      this.showHospitalName = this.$i18n.t('common.All')
      localStorage.brandCodeKey = this.postData.brandCode
      if (this.postData.brandCode.indexOf('_') !== -1) {
        this.hideBtn = true
      } else {
        this.hideBtn = false
      }
      this.moduleList = false
      this.getChannelList()
    },
    yearChange () {
      if (this.postData.version !== 'PreSOP_Shipment' && this.postData.version !== 'SOP_Shipment') {
        this.mktData = false
        this.getMktList()
      } else {
        // this.mktData = false
        // this.getShipmentList()
        if (this.postData.quartersOrMonths !== 3) {
          this.getMktChartData()
        }
      }
    },
    mohChange () {
      if (!(this.mktData && this.mktData.ShipmentInfoModelList && this.mktData.IsEditable)) {
        this.mktData = false
        this.getShipmentList()
      }
    },
    changeQorM (data) {
      if (this.postData.quartersOrMonths !== data) {
        this.postData.quartersOrMonths = data
        if (this.postData.quartersOrMonths === 3) {
          this.showOtherChartFlag = false
          this.chartTableData = false
        }
        this.getMktChartData()
      }
    },
    typeEvent (data) {
      if (this.postData.groupId !== data) {
        this.postData.groupId = data
        this.getMktChartData()
      }
    },
    saveData (value, month, id, remark) {
      let saveObj = {}
      saveObj.id = id
      saveObj.month = month
      saveObj.value = value
      saveObj.version = this.postData.version
      saveObj.remark = remark || ''
      this.saveMktList(saveObj)
    },
    saveDataR (remark, month, id, value) {
      let saveObj = {}
      saveObj.id = id
      saveObj.month = month
      saveObj.value = value
      saveObj.version = this.postData.version
      saveObj.remark = remark || ''
      this.saveMktList(saveObj)
    },
    showNsdDialog () {
      this.showDialog = true
      this.isRouterMktSales = false
      this.$nextTick(() => {
        this.isRouterMktSales = true
        let mktSalesParam = {
          brandCode: this.postData.brandCode,
          year: this.year,
          month: this.month,
          brandName: this.brandName
        }
        sessionStorage.mktSalesParam = JSON.stringify(mktSalesParam)
        this.$router.push({
          name: 'mktSales'
        })
      })
    },
    salesDialogCancel () {
      this.showDialog = false
    },
    showInstruction () {
      this.showInstructionDialog = true
    },
    instructionDialogCancel () {
      this.showInstructionDialog = false
    },
    showCommitDialog () {
      this.mktPrevData = false
      let data = JSON.parse(JSON.stringify(this.postData))
      if (this.postData.version !== 'PreSOP_Shipment' && this.postData.version !== 'SOP_Shipment') {
        let url = this.$commonJs.returnQuery('/api/v1/admin/marketing/preview', data)
        this.$axiox.get(url).then(msg => {
          this.mktPrevData = msg.data || false
          this.showSubmitDialog = true
        })
      } else {
        let isGo = true
        if (this.isAlreadyEdit) {
          isGo = confirm(this.$t('common.NoSaveRefresh'))
        }
        if (isGo) {
          let url = this.$commonJs.returnQuery('/api/v1/admin/shipment/preview', data)
          this.$axiox.get(url).then(msg => {
            this.mktPrevData = msg.data || false
            this.showSubmitDialog = true
          })
        }
      }
    },
    submitConfirm () {
      this.submitData()
    },
    submitShipmentConfirm () {
      let data = JSON.parse(JSON.stringify(this.postData))
      this.$axiox.put('/api/v1/admin/shipment/submit', data).then(msg => {
        this.showSubmitDialog = false
        this.$commonJs.alertTips({
          type: 'success',
          content: this.$t('common.SubmitSuccess'),
          stayTime: 5
        })
        this.getShipmentList()
      })
    },
    submitCancel () {
      this.showSubmitDialog = false
    },
    showChart () {
      if (this.showChartFlag) {
        this.showChartFlag = false
      } else {
        this.showChartFlag = true
      }
    },
    showOtherChart () {
      if (this.showOtherChartFlag) {
        this.showOtherChartFlag = false
      } else {
        this.showOtherChartFlag = true
      }
    },
    /**
     * 是否可编辑
     * @param {*} flag 可编辑
     * @param {*} month 月份
     * @param {*} isShipmentPlan shipment计划
     */
    getCanEdit (flag, month, isShipmentPlan) {
      if (flag) {
        if (isShipmentPlan) {
          if (this.postData.year === this.year) {
            if (month >= this.month) {
              return true
            } else {
              return false
            }
          } else if (this.postData.year < this.year) {
            return false
          } else {
            return true
          }
        } else {
          if (this.postData.year === this.canEditYear) {
            // 从版本年月往后1个月开始填写
            if (month > this.canEditMonth) {
              return true
            } else {
              return false
            }
          } else if (this.postData.year < this.canEditYear) {
            return false
          } else {
            return true
          }
        }
      } else {
        return false
      }
    },
    /*
     * 是否预测-F
     * 年月小于可编辑年月：true
     * 年小于可编辑年：true
     * params year int
     * params month int
     */
    isForecast (year, month) {
      console.log(`year:${year}, month:${month}`)
      console.log(`canEditYear:${this.canEditYear}, canEditMonth:${this.canEditMonth}`)
      if (year === this.canEditYear) {
        if (month <= this.canEditMonth) {
          return true
        } else {
          return false
        }
      } else if (year < this.canEditYear) {
        return true
      } else {
        return false
      }
    },
    getOptionData (dataObj) {
      let optionData = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line'
          }
        },
        grid: {
          left: '200px',
          right: '3%',
          bottom: '3%',
          containLabel: true
        },
        legend: {
          orient: 'horizontal',
          right: '3%',
          top: '15',
          data: [this.postData.year.toString()]
        },
        xAxis: {
          type: 'category',
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          data: dataObj.qList
        },
        yAxis: {
          type: 'value',
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          }
        },
        series: [
          {
            name: this.postData.year,
            yAxisIndex: 0,
            barMaxWidth: 20,
            itemStyle: {
              color: '#398AC4'
            },
            label: {
              show: true,
              position: 'top'
            },
            data: dataObj.seriesList,
            type: 'bar'
          }
        ]
      }
      this.chart.setOption(optionData)
      this.chart.resize()
    },
    getSopOptionData (dataObj, isSecondChart) {
      let optionData = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line'
          }
        },
        color: ['#B62A40', '#EA6D37', '#BF9C37', '#6B853E', '#54BBC3', '#398AC4', '#B62FB1'],
        grid: {
          top: '30',
          left: '200px',
          right: '3%',
          bottom: '3%',
          containLabel: true
        },
        legend: {
          icon: 'rect',
          itemWidth: 10,
          itemHeight: 10,
          orient: 'horizontal',
          right: '20',
          data: dataObj.legendList,
          selected: this.legendSelt
        },
        xAxis: {
          type: 'category',
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          data: dataObj.monthList
        },
        yAxis: [
          {
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            type: 'value'
          }
        ],
        series: dataObj.seriesList
      }
      if (isSecondChart) {
        this.secondChart.setOption(optionData)
        this.secondChart.resize()
      } else {
        this.chart.setOption(optionData)
        this.chart.resize()
      }
    },
    getShipmentOptionData (dataObj) {
      let optionData = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line'
          }
        },
        color: ['#EA6D37', '#B62A40', '#BF9C37', '#6B853E', '#54BBC3', '#398AC4', '#B62FB1'],
        grid: {
          top: '30',
          left: '200px',
          right: '3%',
          bottom: '3%',
          containLabel: true
        },
        legend: {
          icon: 'rect',
          itemWidth: 10,
          itemHeight: 10,
          orient: 'horizontal',
          right: '20',
          data: dataObj.legendList,
          selected: this.legendSelt
        },
        xAxis: {
          type: 'category',
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          data: dataObj.monthList
        },
        yAxis: [
          {
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            type: 'value'
          },
          {
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            splitLine: {
              show: false
            },
            type: 'value'
          }
        ],
        series: dataObj.seriesList
      }
      this.chart.setOption(optionData)
      this.chart.resize()
    },
    getShipmentOptionDataByYear (dataObj) {
      let that = this
      let optionData = {
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            let result = params[0].name + '<br>'
            params.forEach(function (item) {
              if (item.value || item.value === 0) {
                if (item.seriesName === 'Fcst GR%') {
                  result += item.marker + ' ' + item.seriesName + ' : ' + item.value + '%</br>'
                } else {
                  result += item.marker + ' ' + item.seriesName + ' : ' + that.$commonJs.numFixed(item.value) + '</br>'
                }
              } else {
                result += item.marker + ' ' + item.seriesName + ' :  - </br>'
              }
            })
            return result
          },
          axisPointer: {
            type: 'line'
          }
        },
        color: ['#B62A40', '#EA6D37', '#BF9C37', '#6B853E', '#54BBC3', '#398AC4', '#B62FB1', '#6B9C37'],
        grid: {
          top: '30',
          left: '300px',
          right: '3%',
          bottom: '3%',
          containLabel: true
        },
        legend: {
          icon: 'rect',
          itemWidth: 10,
          itemHeight: 10,
          orient: 'horizontal',
          right: '20',
          data: dataObj.legendList,
          selected: that.legendSelt
        },
        xAxis: {
          type: 'category',
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          data: dataObj.monthList
        },
        yAxis: [
          {
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            type: 'value'
          },
          {
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            splitLine: {
              show: false
            },
            type: 'value',
            axisLabel: {
              color: '#B44138',
              formatter: '{value}%'
            }
          }
        ],
        series: dataObj.seriesList
      }
      that.chart.setOption(optionData)
      that.chart.resize()
    },
    getMonthKey (month) {
      let monthKey = ''
      if (month === 1) {
        monthKey = 'Jan'
      } else if (month === 2) {
        monthKey = 'Feb'
      } else if (month === 3) {
        monthKey = 'Mar'
      } else if (month === 4) {
        monthKey = 'Apr'
      } else if (month === 5) {
        monthKey = 'May'
      } else if (month === 6) {
        monthKey = 'Jun'
      } else if (month === 7) {
        monthKey = 'Jul'
      } else if (month === 8) {
        monthKey = 'Aug'
      } else if (month === 9) {
        monthKey = 'Sep'
      } else if (month === 10) {
        monthKey = 'Oct'
      } else if (month === 11) {
        monthKey = 'Nov'
      } else if (month === 12) {
        monthKey = 'Dec'
      }
      return monthKey
    },
    getColor (index) {
      switch (index) {
        case 0:
          return '#B62A40'
        case 1:
          return '#EA6D37'
        case 2:
          return '#BF9C37'
        case 3:
          return '#6B853E'
        case 4:
          return '#54BBC3'
        case 5:
          return '#398AC4'
        case 6:
          return '#B62FB1'
        case 7:
          return '#6B9C37'
        default:
          return '#666'
      }
    }
  }
}
</script>
<style scoped>
  .expendW{
    width: 45px;
  }
  .tdRowBreak{
    white-space: normal;
  }
  .bgColorFDF1F4{
    background: #FDF1F4;
  }
  .tabBlock{
    margin: 0 -10px;
    background-color: #EFEFEF;
    height: 40px;
  }
  .versionTab {
    justify-content: flex-start;
    align-items: flex-end;
  }
  .versionTab button{
    border: none;
    outline: none;
    font-size: 12px;
    padding: 10px 15px;
    align-items: center;
    background-color: #fff;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    margin: 0 10px 0 0;
    color: #B62A40;
    box-shadow: 0px -2px 5px 0px #ccc inset;
  }
  .versionTab button.selected{
    background-color: #B62A40;
    font-weight: bold;
    color: #fff;
    padding: 12px 15px;
    box-shadow: 0px -3px 6px 0px #fff inset;
  }
  .mktVersion{
    flex-direction: column;
    align-items: flex-end;
  }
  .allTable tbody:nth-child(2n){
    background-color: #F8F8F8;
  }
  .allTable tbody:nth-child(2n) tr:nth-child(2n-1){
    background-color: #fff;
  }
  .allTable tbody:nth-child(2n-1) tr:nth-child(2n-1){
    background-color: #F8F8F8;
  }
  .salesBorder{
    border-right: 1px solid #f4d0d9;
  }
  .chartTable{
    position: absolute;
    left: 10px;
    top: 50px;
    width: 180px;
    text-align: center;
    /*line-height: 30px;*/
    border-collapse: collapse;
    z-index: 1;
  }
  .chartTable td{
    padding:0;
    border: 1px solid #E2E2E2;
  }
  .chartArea #mktCharts{
    height: 220px;
    z-index: 0;
  }
  .sopChart{
    height: 170px!important;
    top: 50px;
  }
  .chartRightButton{
    padding: 6px 20px;
  }
  .otherChartButton{
    position: absolute;
    cursor: pointer;
    height: 32px;
    line-height: 32px;
    text-align: center;
    left: 0px;
    top: 187px;
    background: #FDF1F4;
    /*border: 1px solid #B62A40;*/
    color: #C73343;
    font-size: 28px;
    border-radius: 2px;
    z-index: 1;
  }
  .showOtherChart{
    height: 400px;/* +180px*/
    transition: height ease-out 0.4s;
  }
  .divider {
    background-color: #dcdfe6;
    position: relative;
  }
  .divider--horizontal {
    display: block;
    height: 1px;
    width: 100%;
    margin: 16px 0;
  }
  .divider__text {
    position: absolute;
    background-color: #fff;
    padding: 0 20px;
    font-weight: 500;
    color: #303133;
    font-size: 14px;
  }
  .divider__text.is-center {
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
  }
  .divider__text.is-left {
    left: 20px;
    transform: translateY(-50%);
  }
  .divider__text.is-right {
    right: 20px;
    transform: translateY(-50%);
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/gileadSales/mktReport.vue